import { render } from "./DepartmentTMS.vue?vue&type=template&id=5c594cf4&scoped=true"
import script from "./DepartmentTMS.vue?vue&type=script&lang=js"
export * from "./DepartmentTMS.vue?vue&type=script&lang=js"

import "./DepartmentTMS.vue?vue&type=style&index=0&id=5c594cf4&scoped=true&lang=css"

import exportComponent from "D:\\bkp\\my-vue-pwa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c594cf4"]])

export default __exports__